import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PageBack from "../components/buttons/page-back";
import {db_tables, DBHelpers, rd, type_media} from "../../vars/rd";
import DaoPlayerMedia from "../../modules/dao/player.media";

class EventLogs extends Component {

    constructor(props) {
        super(props);
        /**
         *
         * @type {{ments: DaoPlayerMedia[], events: DaoEvent[]}}
         */
        this.state = {
            ments: [],
            events: []
        };
    }

    async componentDidMount() {
        this.mounted = true;
        DBHelpers.openDB()
            .then(async db => {
                if(this.mounted) {
                    const ments = [];
                    let _ments = await db.selectBulk(db_tables.history, doc => {
                        return doc.type !== type_media.bgm &&
                            doc.groupid === rd.user.groupid &&
                            doc.serviceid === rd.user.serviceid;
                    });
                    _ments = (_ments || []).reverse();
                    _ments.forEach(_ment => {
                        ments.push(new DaoPlayerMedia(_ment));
                    });
                    this.setState({ments});
                }
            });
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    /**
     * @returns {DaoPlayerMedia[]}
     */
    get ments() {
        return this.state.ments;
    }

    /**
     * @returns {DaoEvent[]}
     */
    get events() {
        return this.state.events;
    }

    render() {
        return (
            <div className="log">
                <h2>
                    <PageBack />
                    이벤트 로그
                </h2>
                <div className="log-wrap">
                    <div className="m-log-tab">
                        <div className="tab-slider--nav">
                            <ul className="tab-slider--tabs">
                                <li className="tab-slider--trigger active" rel="tab1">방송 송출 이력</li>
                                <li className="tab-slider--trigger" rel="tab2">오류 발생 이력</li>
                            </ul>
                        </div>
                    </div>

                    <div className="log-list-wrap">
                        <div id="tab1" className="box">
                            <div className="title">
                                <h4>방송 송출 이력</h4>
                                <ul className="title-list">
                                    <li>
                                        <div className="time">송출 시각</div>
                                        <div className="name">방송명</div>
                                    </li>
                                </ul>
                            </div>
                            {
                                this.ments.length ?
                                    <div className="list">
                                        {
                                            this.ments.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <div className="time">{item.date} {item.at}</div>
                                                        <div className="name">{item.songname}</div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </div> :
                                    <div className="list">
                                        <div className="no-data">방송 송출 이력이 없습니다.</div>
                                    </div>
                            }
                        </div>
                        <div id="tab2" className="box">
                            <div className="title">
                                <h4>오류 발생 이력</h4>
                                <ul className="title-list">
                                    <li>
                                        <div className="time">발생 시각</div>
                                        <div className="name">이벤트명</div>
                                    </li>
                                </ul>
                            </div>

                            {
                                this.events.length ?
                                    <div className="list">
                                        {
                                            this.events.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <div className="time">{item.date} {item.time}</div>
                                                        <div className="name">{item.message}</div>
                                                    </li>
                                                );
                                            })
                                        }
                                    </div> :
                                    <div className="list">
                                        <div className="no-data">이벤트 이력이 없습니다.</div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(withRouter(EventLogs));


// WEBPACK FOOTER //
// ./src/pages/event.logs/index.jsx